import { render, staticRenderFns } from "./ViewBigfox.vue?vue&type=template&id=312d3388&"
import script from "./ViewBigfox.vue?vue&type=script&lang=js&"
export * from "./ViewBigfox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports